import mapboxgl from "mapbox-gl";

/**
 * Map instance registry using window to survive Vite HMR module reloads.
 * Module-level singletons can be duplicated by HMR, so we store on window
 * to guarantee a single shared reference across all imports.
 */

declare global {
  interface Window {
    __mapInstanceRegistry?: mapboxgl.Map | null;
  }
}

export function setMapInstance(map: mapboxgl.Map | null): void {
  window.__mapInstanceRegistry = map;
}

export function getMapInstance(): mapboxgl.Map | null {
  return window.__mapInstanceRegistry ?? null;
}
